import { SortOrder } from "antd/es/table/interface"

interface Props {
    order: SortOrder
}
const SortIcon = ({ order }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M1.75 9.83333L4.08333 12.1667L6.41667 9.83333" stroke={order == "ascend" ? "#0152FB" : "#667085"} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.0835 12.1667V2.83333" stroke={order == "ascend" ? "#0152FB" : "#667085"} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.2502 5.16666L9.91683 2.83333L7.5835 5.16666" stroke={order == "descend" ? "#0152FB" : "#667085"} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.9165 2.83333V12.1667" stroke={order == "descend" ? "#0152FB" : "#667085"} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default SortIcon